import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{staticClass:"content-container"},[_c(VCardTitle,{staticClass:"justify-center",attrs:{"primary-title":""}},[_c('div',[_vm._v("\n      "+_vm._s(_vm.$t("Welcome"))+"\n    ")])]),_c(VRow,{attrs:{"align":"center","justify":"end"}},[_c(VImg,{staticStyle:{"margin-top":"90px"},attrs:{"src":require("@/assets/logo.png"),"height":"30vh","width":"50vw","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }